import { URL } from "../../utils/UrlConstants";
import { CONSTANT } from "../../utils/Constants";
import { privateFetch } from "../../utils/notifications";

export const getAllNotifications = async () => {
	try {
		const response = await privateFetch.get(
			URL.REQUEST_NOTIFICATIONS_LIST()
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

export const createNotification = async (data: any) => {
	try {
		const response = await privateFetch.post(
			URL.REQUEST_CREATE_NOTIFICATION(),
			JSON.stringify(data),
			{
				headers: {
					...CONSTANT.HEADER_TYPE,
				},
			}
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

export const getNotificationByName = async (eventName: string) => {
	try {
		const response = await privateFetch.get(
			URL.REQUEST_NOTIFICATION_BY_NAME(eventName)
		);
		return response.data;
	} catch (error: any) {
		// Si el error es 404, significa que no existe la notificación
		if (error?.response?.status === 404) {
			return null;
		}
		throw new Error(error);
	}
};

export const deleteNotification = async (eventName: string) => {
	try {
		const response = await privateFetch.delete(
			URL.REQUEST_DELETE_NOTIFICATION(eventName)
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};

export const updateNotificationStatus = async (eventId: number, statusData: any) => {
	try {
		const response = await privateFetch.put(
			URL.REQUEST_UPDATE_NOTIFICATION_STATUS(eventId),
			JSON.stringify(statusData),
			{
				headers: {
					...CONSTANT.HEADER_TYPE,
				},
			}
		);
		console.log("Update response:", response);
		return response.data;
	} catch (error: any) {
		throw new Error(error);
	}
};
